/* This file was GENERATED from the Webflow capture, which has since been
 * retired — see DESIGN-SYSTEM-PLAN.md. There is no generator any more: this is
 * now ordinary source, and editing it by hand is how you change it.
 */
import type { ComponentType } from 'react'

/** Every ported page, lazily loaded so a visit downloads only its own markup. */
export const PORTED_PAGES: Record<string, () => Promise<{ default: ComponentType }>> = {
  "/about": () => import('@/pages/about'),
  "/ai-email-editor": () => import('@/pages/ai-email-editor'),
  "/demo": () => import('@/pages/demo'),
  "/": () => import('@/pages/home'),
  "/marketing-automation": () => import('@/pages/marketing-automation'),
  "/modular-communication-strategy-architecture-whitepaper": () => import('@/pages/modular-communication-strategy-architecture-whitepaper'),
  "/newsletter": () => import('@/pages/newsletter'),
  "/privacy": () => import('@/pages/privacy'),
  "/roi-calculator": () => import('@/pages/roi-calculator'),
  "/singulate-certified-partner-program": () => import('@/pages/singulate-certified-partner-program'),
}

export const PORTED_ROUTES = Object.keys(PORTED_PAGES)

/**
 * Which promo campaign each route carried, for the 18 of 59 that had one.
 *
 * Not site-wide chrome: it renders only where the capture had it, and the
 * capture holds two campaigns — the homepage's older Wayback snapshot ran a
 * Marketo announcement where the rest ran a webinar.
 *
 * Empty from the Webflow cutover until the Oct 19, 2026 Studio launch, which
 * runs the "studio" variant on the homepage. To run a promo on another route,
 * map it to a variant here.
 */
export const PROMO_VARIANT: Record<string, 'webinar' | 'marketo' | 'studio'> = {
  // Studio public launch, Oct 19, 2026. Homepage only; add a route here to run the strip there too.
  "/": "studio",
}

/*
 * Head metadata used to live here as a second PAGE_META, keyed by route. It
 * drifted from the one `build-seo` reads — seven descriptions and a title were
 * only ever updated in one of the two — so `DocumentHead` now reads
 * `META_BY_ROUTE` from `@/content/pages/pages.generated` and this copy is gone.
 * One source of truth for a page's title, description and OG image.
 */
